import { render, staticRenderFns } from "./LimitedCreatorForm.vue?vue&type=template&id=68bfcb00&scoped=true&"
import script from "./LimitedCreatorForm.vue?vue&type=script&lang=ts&"
export * from "./LimitedCreatorForm.vue?vue&type=script&lang=ts&"
import style0 from "./LimitedCreatorForm.vue?vue&type=style&index=0&id=68bfcb00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfcb00",
  null
  
)

export default component.exports